import { render, staticRenderFns } from "./SylvanaMenuOpen.vue?vue&type=template&id=1545fa62&"
import script from "./SylvanaMenuOpen.vue?vue&type=script&lang=ts&"
export * from "./SylvanaMenuOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports